
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import NR, { CodeForm, LoginFrom, Info, Login } from "@/lib/model/NRXQ/nr";
import { ElForm } from "element-ui/types/form";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import Reg from "@/lib/common/Reg";
import QA from "@/views/paper/components/QA.vue";

import Config from "@/config/config";

@Component({
  components: {
    QA
  }
})
export default class NrLogin extends Vue {
  @Prop({ default: "", type: String }) connectCode!: string;
  @Prop({ default: true, type: Boolean }) isPc!: boolean;

  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  sendingCaptchaLock = false;
  loginLock = false;
  captchaLoginError = false;
  captchaErrorText = "";
  isSelected = false;
  locationOrigin = "";
  showQA = false;
  atsCompanyOutId = "";
  atsUserOutId = "";
  rules = {
    email: [
      { required: true, message: "请输入邮箱号", trigger: "change" }
      //   {
      //     validator: (rule: unknown, value: string, callback: Function) => {
      //       if (!Reg.isMobile(value)) {
      //         return callback(new Error("手机号格式不正确"));
      //       } else {
      //         return callback();
      //       }
      //     },
      //     trigger: ["blur"]
      //   }
    ],
    passwdMd5: [{ required: true, message: "请输入密码", trigger: "change" }]
  };
  isLogin = true; //登录 or 找回
  isFinding = false; //输入新密码
  sendEmail = false; //是否已发
  sendedEmailText = ""; //已发送至
  email = ""; //找回中的email
  sign = ""; //重置密码 时效
  routeDone = false;

  get hasMobile() {
    return this.loginFrom.email !== "" && this.loginFrom.email.length === 11;
  }

  created() {
    this.createdToDo();
  }
  //加载对应页面
  createdToDo() {
    const p = this.$route.query;
    // if (!p.atsCompanyOutId && !p.atsUserOutId) {
    //   this.$message.warning("您输入的链接不正确，请核对后再试");
    //   return;
    // }
    this.isLogin = (p?.isForget as string) === "1" ? false : true; //登录还是找回
    this.isFinding = (p?.isFinding as string) === "1" ? true : false; //找回密码的二次确认页面
    //已登录 去首页
    if (this.isLogin && !this.isFinding && localStorage.getItem("nrToken")) {
      this.$router.push("/public/list-nr");
      return;
    }
    //记下参数
    this.atsCompanyOutId =
      (p?.atsCompanyOutId as string) ||
      String(localStorage.getItem("atsCompanyOutId") || ""); //公司id
    this.atsUserOutId = p?.atsUserOutId as string; //用户id
    this.sign = p?.sign as string; //找回时效
    //去设置新密码
    if (this.isFinding) {
      this.getUserInfo();
    }

    this.clear();
    this.routeDone = true;
  }
  mounted() {
    this.locationOrigin = Config.homePageHost;
    console.log(this.locationOrigin);
  }
  //用户信息
  getUserInfo() {
    Login.getUserInfo({ atsUserOutId: this.atsUserOutId })
      .then(res => {
        if (res.data.code === 0) {
          console.log(res.data);
          this.email = res?.data?.data?.atsUser?.email;
          this.atsUserOutId = res?.data?.data?.atsUser?.atsUserOutId;
          this.atsCompanyOutId = res?.data?.data?.atsCompany?.atsCompanyOutId;
        }
      })
      .catch(() => {
        //
      });
  }
  clear() {
    this.$nextTick(() => {
      this.loginFrom = new LoginFrom();
      (this.$refs["formForget"] as any)?.clearValidate();
      (this.$refs["form"] as any)?.clearValidate();
    });
  }
  //发送找回邮件
  submitForget() {
    // if (this.sendingCaptchaLock) {
    //   return;
    // }
    // if (this.seconds > 0) {
    //   return;
    // }
    if (!this.loginFrom.email) {
      this.$message.warning("请先输入您的邮箱");
      return;
    }
    // this.sendingCaptchaLock = true;
    this.sendEmail = true;
    this.sendedEmailText = this.loginFrom.email;
    // 发送找回邮件
    Login.forget({
      // atsCompanyOutId: this.atsCompanyOutId,
      email: this.loginFrom.email
    })
      .then(() => {
        // this.seconds = 60;
        // this.interval = setInterval(() => {
        //   this.seconds--;
        //   if (this.seconds <= 0) {
        //     clearInterval(this.interval);
        //     this.sendingCaptchaLock = false;
        //   }
        // }, 1000);
      })
      .catch((err: any) => {
        this.captchaErrorText = err.message;
        this.captchaLoginError = true;
      })
      .finally(() => {
        // this.sendingCaptchaLock = false;
      });
  }
  //确认新密码
  submitPW() {
    if (this.loginFrom.passwdMd5Chk === "" || this.loginFrom.passwdMd5 === "") {
      this.$message.warning("请将密码填写完整");
      return;
    }
    if (this.loginFrom.passwdMd5Chk !== this.loginFrom.passwdMd5) {
      this.$message.warning("两次输入的密码不一致");
      return;
    }
    if (
      this.loginFrom.passwdMd5Chk.length < 6 ||
      this.loginFrom.passwdMd5.length < 6
    ) {
      this.$message.warning("密码长度需为6-18位");
      return;
    }
    (this.$refs["formFinding"] as any)?.validate((valid: any) => {
      if (valid) {
        this.loginFrom.atsUserOutId = this.atsUserOutId;
        this.loginFrom.email = this.email;
        this.loginFrom.sign = this.sign;
        return Login.sendNewPassword(this.loginFrom)
          .then((resp: any) => {
            if (resp.data.code !== 0) return;
            const info = resp.data.data;

            this.$message.success("设置成功");
            this.toLogin();
          })
          .catch((err: any) => {
            //
          })
          .finally(() => {
            //
          });
      }
    });
  }
  //登录
  submit() {
    if (this.loginLock) return;
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        this.captchaLoginError = false;
        this.loginLock = true;
        // this.loginFrom.atsCompanyOutId = this.atsCompanyOutId;
        return Login.login(this.loginFrom)
          .then((resp: any) => {
            if (resp.data.code !== 0) return;
            const info = resp.data.data;
            //登录成功后 存下模拟token
            try {
              localStorage.setItem("nrToken", info.atsUserToken);
              localStorage.setItem("atsCompanyOutId", this.atsCompanyOutId);
              localStorage.setItem("atsUserOutId", info.atsUser.atsUserOutId);
            } catch (e) {
              console.log(e);
            }
            this.$router.push("/public/list-nr");
          })
          .catch((err: any) => {
            this.captchaErrorText = err.message;
            this.captchaLoginError = false;
          })
          .finally(() => {
            this.loginLock = false;
          });
      }
    });
  }
  toLogin() {
    const url = "/public/login-nr";
    // const url = "/login-nr?atsCompanyOutId=" + this.atsCompanyOutId;
    this.$router.push(url);
    this.routeDone = false;
    this.$nextTick(() => {
      this.createdToDo();
    });
  }
}
